import { QueryBuilderIcon } from "@graphiql/react";
import { QueryBuilder } from "./components/query-builder.js";
/* empty css          */
const QUERY_BUILDER_PLUGIN = {
  title: "Query Builder",
  icon: QueryBuilderIcon,
  content: QueryBuilder
};
export {
  QUERY_BUILDER_PLUGIN,
  QueryBuilder
};
//# sourceMappingURL=index.js.map
